import { Lead } from "./lead.model";
import { Partner } from "./partner.model";
import { ContactMotivation } from "./requests/createContactRequest.model";



export interface ContactRequest {
    id: number;
    lead: Lead;
    partner: Partner;
    motivation?: ContactMotivation;
    status: ContactStatus;
}

export enum ContactStatus {
    UNVERIFIED = 'UNVERIFIED',
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    ARCHIVED = 'ARCHIVED',
    UNLOCKED = 'UNLOCKED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED'
}